import type React from 'react';

import Switch from '@molecules/Switch';

function ShowAudienceProfile({
  checked,
  onChange
}: {
  checked: boolean;
  onChange: (checked: boolean) => void;
}) {
  return (
    <div className="flex">
      <div className="flex-1 text-sm">
        Display audience profile
      </div>
      <Switch
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        onClick={() => {}}
      />
    </div>
  );
}

export default ShowAudienceProfile;
